export default __webpack_public_path__ + "static/img-abouteambanner-9449d0e94b0087d234c0951b5a316e3e.jpg";